import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AppConfig {
  apiBaseUrl?: string;
}

/** Runtime config (e.g. from /assets/config.json). Overrides environment for production deployments. */
@Injectable({ providedIn: 'root' })
export class ConfigService {
  private _apiBaseUrl: string = '';

  get apiBaseUrl(): string {
    const raw = (this._apiBaseUrl || (environment?.apiBaseUrl ?? '')).replace(/\/$/, '');
    // In production, do not fall back to localhost; require config.json.
    if (environment.production && !raw) return '';
    // Dev-only default so ng serve works without config.json; no URL is committed in environment files.
    return raw || 'http://localhost:8081';
  }

  set apiBaseUrl(value: string) {
    this._apiBaseUrl = (value ?? '').replace(/\/$/, '');
  }

  constructor(private http: HttpClient) {}

  /** Load config from /assets/config.json. Call from APP_INITIALIZER. */
  load(): Promise<void> {
    return firstValueFrom(this.http.get<AppConfig>('/assets/config.json')).then(
      (c) => {
        if (c?.apiBaseUrl != null && c.apiBaseUrl !== '') {
          this.apiBaseUrl = c.apiBaseUrl;
        }
      }
    ).catch(() => {
      // No config.json or network error: use environment defaults
    });
  }
}
